/* eslint-disable max-len */
import { FoldersTranslations } from '../interfaces/folders';

const PolishFoldersTranslations: FoldersTranslations = {
  toolbar: {
    expandAll: 'Rozwiń wszystko',
    collapseAll: 'Zwiń wszystko',
    newFolder: 'Nowy folder',
    newList: 'Nowa lista',
    cancelSelection: 'Anuluj zaznaczanie',
    deleteMany: 'Usuń wiele',
    bulkModeTooltip: 'Tryb zaznaczania wielu',
    search: 'Szukaj',
  },
  tree: {
    loading: 'Ładowanie struktury folderów...',
    noResults: 'Brak wyników dla "{{query}}"',
    clearSearch: 'Wyczyść wyszukiwanie',
    subfolders: 'Podfoldery: {{n}}',
    listsCount: 'Liczba list (łącznie z podfolderami)',
    createdAt: 'Data utworzenia',
    wordsCount: 'Liczba słów',
  },
  menu: {
    newSubfolder: 'Nowy podfolder',
    newList: 'Nowa lista',
    rename: 'Zmień nazwę',
    move: 'Przenieś',
    share: 'Udostępnij',
    edit: 'Edytuj',
    duplicate: 'Duplikuj',
  },
  createFolder: {
    title: 'Nowy folder',
    titleSub: 'Nowy podfolder',
    placeholder: 'Nazwa folderu',
  },
  createList: {
    title: 'Nowa lista',
    titleInFolder: 'Nowa lista w folderze',
    name: 'nazwa',
    description: 'opis',
    inFolderInfo: 'Lista zostanie utworzona w wybranym folderze',
  },
  move: {
    moveFolder: 'Przenieś folder:',
    moveList: 'Przenieś listę:',
    duplicateFolder: 'Duplikuj folder:',
    duplicateList: 'Duplikuj listę:',
    chooseTarget: 'Wybierz folder docelowy:',
    chooseForCopy: 'Wybierz folder dla kopii:',
    search: 'Szukaj folderu…',
    root: 'Katalog główny',
    move: 'Przenieś',
    duplicate: 'Duplikuj',
  },
  delete: {
    folderTitle: 'Usuń folder',
    listTitle: 'Usuń listę',
    listConfirm: 'Czy na pewno chcesz usunąć listę "{{name}}"?',
    folderConfirm: 'Czy na pewno chcesz usunąć folder "{{name}}"?',
    folderWithChildren: 'Folder "{{name}}" zawiera {{n}} elementów...',
    bulkTitle: 'Usuń {{n}} elementów',
    bulkConfirm: 'Czy na pewno chcesz usunąć wybrane elementy?',
    tooManyTitle: 'Zbyt wiele elementów',
    tooManyContent: 'Możesz usunąć maksymalnie {{max}} elementów na raz.',
  },
  validation: {
    nameEmpty: 'Nazwa nie może być pusta',
    nameTooLong: 'Nazwa za długa (max {{max}} znaków)',
    nameInvalid: 'Nazwa zawiera niedozwolone znaki',
  },
  messages: {
    maxNesting: 'Maksymalnie {{max}} poziomów zagnieżdżenia',
    nestingTitle: 'Przekroczono limit zagnieżdżenia',
    nestingContent: 'Maksymalna dozwolona liczba poziomów to {{max}}.',
    folderMoved: 'Folder został przeniesiony',
    listMoved: 'Lista została przeniesiona',
    moveError: 'Błąd podczas przenoszenia',
    deleteError: 'Błąd podczas usuwania',
    createFolderError: 'Błąd podczas tworzenia folderu',
    listCreated: 'Lista została utworzona',
    createListError: 'Nie udało się utworzyć listy',
    listDataNotFound: 'Nie znaleziono danych listy',
    duplicateError: 'Błąd podczas duplikowania',
    copySaved: 'Kopia listy zapisana',
    copyNotMoved: 'Kopia powstała, ale nie udało się jej przenieść — jest w folderze oryginału',
    nothingSelected: 'Nie wybrano żadnych elementów',
    itemsDeleted: 'Elementy zostały usunięte',
    bulkDeleteError: 'Wystąpił błąd podczas usuwania',
    cannotMoveIntoList: 'Nie można przenieść elementu do listy',
    cannotMoveIntoItself: 'Nie można przenieść elementu do samego siebie',
    cannotMoveIntoSubfolder: 'Nie można przenieść folderu do jego podfolderu',
    listTooShort: 'Lista musi zawierać minimum 2 słowa',
    listLoadError: 'Nie udało się załadować listy',
    listActivated: 'Lista aktywowana - dane zostaną załadowane',
    treeLoadError: 'Nie udało się załadować struktury folderów',
    folderCreated: 'Folder został utworzony',
    folderRenamed: 'Folder został pomyślnie przemianowany',
    listRenamed: 'Lista została pomyślnie przemianowana',
    renameError: 'Nie udało się zmienić nazwy',
    folderDeleted: 'Folder został usunięty',
    folderDeleteError: 'Nie udało się usunąć folderu',
    itemMoveError: 'Nie udało się przenieść elementu',
    itemsDeleteError: 'Błąd podczas usuwania elementów',
    itemNotDeleted: 'Nie udało się usunąć elementu',
    folderLoadError: 'Nie udało się załadować zawartości folderu',
  },
};

export default PolishFoldersTranslations;
